import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconMap: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.6722 3.2C21.3711 3 21.07 3 20.7689 3.1L15.9512 5L8.22284 3C8.12247 3 7.92173 3 7.82137 3H7.721L2.70258 5C2.20074 5.2 2 5.6 2 6V20C2 20.3 2.20074 20.6 2.40147 20.8C2.60221 20.9 2.80295 21 3.00368 21C3.10405 21 3.30479 21 3.40516 20.9L8.12247 19L15.8508 20.9C15.9512 20.9 16.0516 20.9 16.0516 20.9C16.1519 20.9 16.2523 20.9 16.3527 20.8L21.3711 18.8C21.7726 18.6 21.9733 18.3 21.9733 17.9V4C22.0737 3.7 21.8729 3.4 21.6722 3.2ZM4.00737 6.7L7.01842 5.5V17.3L4.00737 18.5V6.7ZM9.02579 5.3L15.0479 6.8V18.7L9.02579 17.2V5.3ZM20.0663 17.3L17.0553 18.5V6.7L20.0663 5.5V17.3Z',
    })
  )
}
